import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "../features/admin/adminSlice";
import adminAuthReducer from "../features/admin/authSlice";

export const store = configureStore({
 reducer: {
  admin: adminReducer,
  adminAuth: adminAuthReducer,
 },
});
